export const isLogin = !!localStorage.getItem('session')

export const login = () => {
    const { origin, href } = window.location
    const path = `${origin}/pages/login.html#/?path=${encodeURIComponent(href)}`
    window.location.href = path
}
